import React, { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../main/Header";
import Footer from "../main/Footer";
import TopBar from "../main/TopBar"; // Ensure this path is correct based on App.jsx imports
import TopDisclaimer from "../TopDisclaimer";
import Top from "../Top";
import CookieConsentBanner from "../ui/CookieConsentBanner";
import Chatbot from "../ui/Chatbot";
import AutoDebugger from "../../debug";

const PublicShell = () => {
    // This shell wraps all public pages
    // It assumes LanguageLayout has already handled language validation

    const location = useLocation();
    const currentPath = location.pathname.replace(/^\/(?:en|ar|es|fa|hy|ru|tl|zh-CN|ko|hi-Guj)/, '') || '/';
    const cleanPath = currentPath.split('?')[0].split('#')[0];
    
    // dynamically import the mappings
    const [h1Data, setH1Data] = React.useState({ title: 'Westlake Village Hospice' });
    React.useEffect(() => {
        import('../../seo/headings.js').then(module => {
            const h1Match = module.pageH1[cleanPath] || module.getH1FromSlug(cleanPath.split('/').pop());
            setH1Data({ title: h1Match });
        }).catch(e => console.error(e));
    }, [cleanPath]);


    return (
        <>
            <TopDisclaimer />
            {/* <TopBar /> */}
            <Header />
            <Top />

            <Suspense
                fallback={
                    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50">
                        <div className="text-center">
                            <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                            <p className="text-slate-600 text-lg">Loading...</p>
                        </div>
                    </div>
                }
            >
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-4">
                    <h1 className="page-h1 text-blue-900 font-bold text-center text-2xl md:text-3xl my-4" style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                        {h1Data.title}
                    </h1>
                </div>
                <Outlet />
            </Suspense>

            <Footer />
            <CookieConsentBanner />
            <Chatbot />

            {/* Auto Debugger — only active in development (no-op in production) */}
            <AutoDebugger />
        </>
    );
};

export default PublicShell;
